module.exports = __webpack_public_path__ + "static/media/footer-bg.b2dce4cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/footer-bg.png
// module id = 311
// module chunks = 0